<template>
    <div class="dialog" v-show="showCreatedImg">
        <div class="mask"></div>
        <img id="starImg" ref="img" :src="src" v-show="showCanvas"/>
        <div class="button">
            <div class="share_card" @click="shareCard" data-rlog="share-certificate"></div>
            <div class="go_back" @click="goBack" data-rlog="generate-certificate"></div>
        </div>
        <div class="toast" v-if="toast">长按图片发送给朋友</div>
    </div>
</template>

<script>
    import { isYouDao, ydk, setShare } from './../libs/libs.js'
    export default {
        name: 'App',
        data () {
            return {
                src: '',
                showCanvas: false,
                toast: false
            }
        },
        props: {
            vocabulary: '',
            showCreatedImg: ''
        },
        
        watch: {
            showCreatedImg: function (val) {
                if (val) {
                    this.createdImg()
                }
            },
            vocabulary: function (val) {
                if (this.$store.state.userName != '') {
                    this.createdImg()
                }
            }
        },
        methods: {
            createdImg: function () {
                let that= this
                let canvas = document.createElement('canvas'); 
                let mainCtx =  canvas.getContext("2d");
                let w = document.body.clientWidth
                let img = new Image();
                img.crossOrigin = 'Anonymous'
                img.src = this.getImg()
                img.onload = function () {
                    canvas.width = w * 0.83 * 4
                    canvas.height = w * 0.83 / 620 * 820 * 4
                    mainCtx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    if (that.$store.state.userName) {
                        let fontSize = w/750*24*4
                        let left = canvas.width/2
                        let height = canvas.height*(320/820)
                        mainCtx.textAlign = 'center'
                        mainCtx.font = `normal ${fontSize}px DINAlternateBold`
                        mainCtx.fillStyle = "rgba(77,63,49,1)";
                        mainCtx.fillText(`${that.$store.state.userName}的单词量`, left, height);
                    }
                    if (that.vocabulary != -1) {
                        let fontSize = w / 750 * 90 * 4
                        let left = canvas.width / 2
                        let height = canvas.height * (430 / 820)
                        mainCtx.textAlign = 'center'
                        mainCtx.font = `normal ${fontSize}px DINAlternateBold`
                        mainCtx.fillStyle = "#ff9b25"
                        mainCtx.fillText(`${that.$store.state.lastVocabulary}`, left, height);
                    }
                    let src = canvas.toDataURL("image/png");
                    that.src = src
                    that.showCanvas = true
                }
            },
            goBack: function () {
                this.$emit('hiddenDialog',false)
            },
            shareCard: function () {
                let that = this
                if(isYouDao != -1) {
                    let str = `不吹不黑，我的词汇量达到${this.$store.state.lastVocabulary}`
                    setShare(str, false)
                } else {
                    that.toast = true
                    setTimeout(() => {
                        that.toast = false
                    }, 2000);
                }
            },
            getImg: function () {
                let src
                let vocabulary = this.$store.state.lastVocabulary
                if ( 0 < vocabulary && vocabulary < 1000 ) {
                    return src = 'http://shared.youdao.com/dict/market/recite-vocabulary/imgs/1.png?b=1'
                }
                if ( vocabulary < 2000 ) {
                    return src = 'http://shared.youdao.com/dict/market/recite-vocabulary/imgs/2.png?b=1'
                }
                if ( vocabulary < 3000 ) {
                    return src = 'http://shared.youdao.com/dict/market/recite-vocabulary/imgs/3.png?b=1'
                }
                if ( vocabulary < 4000 ) {
                    return src = 'http://shared.youdao.com/dict/market/recite-vocabulary/imgs/4.png?b=1'
                }
                if ( vocabulary < 5500 ) {
                    return src = 'http://shared.youdao.com/dict/market/recite-vocabulary/imgs/5.png?b=1'
                }
                if ( vocabulary < 6500 ) {
                    return src = 'http://shared.youdao.com/dict/market/recite-vocabulary/imgs/6.png?b=1'
                }
                if ( vocabulary < 8500 ) {
                    return src = 'http://shared.youdao.com/dict/market/recite-vocabulary/imgs/7.png?b=1'
                }
                if ( vocabulary < 10000 ) {
                    return src = 'http://shared.youdao.com/dict/market/recite-vocabulary/imgs/8.png?b=1'
                }
                if ( vocabulary < 13000 ) {
                    return src = 'http://shared.youdao.com/dict/market/recite-vocabulary/imgs/9.png?b=1'
                }
                if ( vocabulary < 15000 ) {
                    return src = 'http://shared.youdao.com/dict/market/recite-vocabulary/imgs/10.png?b=1'
                }
                if ( vocabulary < 14999 ) {
                    return src = 'http://shared.youdao.com/dict/market/recite-vocabulary/imgs/11.png?b=1'
                }
            }
        }
    }
</script>

<style>
    @font-face { 
        font-family: DINAlternateBold; /*这里是说明调用来的字体名字*/ 
        src: url(http://shared.youdao.com/dict/market/recite-vocabulary/fonts/DINAlternateBold.ttf); /*这里是字体文件路径*/ 
    }
    .dialog {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .mask {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: #000000;
        opacity: 0.4;
    }
    canvas {
        width: 6.2rem;
        height: 9.97rem;
    }
    #starImg {
        width: 6.2rem;
        height: 8.2rem;
        position: fixed;
        display: block;
        top: 1.24rem;
        left: 50%;
        bottom: 0;
        right: 0;
        margin-left: -3.1rem;
    }
    .dialog .butten {
        width: 100px;
        height: 100px;
        position: fixed;
        top: 0;
        z-index: 10000;
    }
    .dialog .button {
        width: 100%;
        height: 1.36rem;
        position: fixed;
        bottom: 0;
        z-index: 99;
        background-image: url();
    }
    .dialog .share_card {
        width: 3.15rem;
        height: 1.1rem;
        margin-left: 0.4rem;
        float: left;
        background-image: url('http://shared.youdao.com/dict/market/recite-vocabulary/img/page4_button1@3x.png');
        background-size: 100% 100%;
        
    }
    .dialog .go_back {
        width: 3.15rem;
        height: 1.1rem;
        margin-right: 0.4rem;
        float: right; 
        background-image: url('http://shared.youdao.com/dict/market/recite-vocabulary/img/page4_button2.png');
        background-size: 100% 100%;
    }
    .toast {
        width: 5.16rem;
        height: 1.4rem;
        background: rgba(72,78,94,1);
        border-radius: 0.33rem;
        font-size: 0.32rem;
        font-family: PingFangSC-Semibold;
        color: rgba(255,255,255,1);
        position: fixed;
        top: 5.97rem;
        left: 50%;
        margin-left: -2.58rem;
        text-align: center;
        line-height: 1.4rem;
        opacity: 0.7;
    }
</style>



// WEBPACK FOOTER //
// src/components/CreatImg.vue